import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoDinamikKesit } from '../FikoDinamikKesit';
import { FikoYTService } from '@/src/service/fikoyt.service';

@Component({
    selector: 'fikoyt-duzlem-hareket-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './duzlem-hareket-dialog.component.html',
    styleUrls: ['./duzlem-hareket-dialog.component.scss']
})
export class DuzlemHareketDialogComponent {
    id_dialog = "dialogDuzlemHareket" + this.FikoYT.fikoIdUret();

    @Input() dinamikKesit!: FikoDinamikKesit;
    @Input() pencere: any; // Dialog Core'dan gelen pencere referansı

    // Hareket miktarları
    hizliHareketMiktari: number = 10;
    yavasHareketMiktari: number = 0.5;

    // Dönme açısı
    dondurmeAcisi: number = 15;

    constructor(
        public readonly FikoYT: FikoYTService,
        public readonly CD: ChangeDetectorRef
    ) {}

    // Hareket kontrolleri
    duzlemIleri() {
        this.dinamikKesit.duzlemHareketEttir(this.hizliHareketMiktari);
    }

    duzlemGeri() {
        this.dinamikKesit.duzlemHareketEttir(-this.hizliHareketMiktari);
    }

    duzlemYavasIleri() {
        this.dinamikKesit.duzlemHareketEttir(this.yavasHareketMiktari);
    }

    duzlemYavasGeri() {
        this.dinamikKesit.duzlemHareketEttir(-this.yavasHareketMiktari);
    }

    // Dönme kontrolleri
    duzlemDondurX(yon: number) {
        const axis = new (window as any).THREE.Vector3(1, 0, 0);
        const angle = (this.dondurmeAcisi * Math.PI / 180) * yon;
        this.dinamikKesit.duzlemDondur(axis, angle);
    }

    duzlemDondurY(yon: number) {
        const axis = new (window as any).THREE.Vector3(0, 1, 0);
        const angle = (this.dondurmeAcisi * Math.PI / 180) * yon;
        this.dinamikKesit.duzlemDondur(axis, angle);
    }

    duzlemDondurZ(yon: number) {
        const axis = new (window as any).THREE.Vector3(0, 0, 1);
        const angle = (this.dondurmeAcisi * Math.PI / 180) * yon;
        this.dinamikKesit.duzlemDondur(axis, angle);
    }

    // Preset eksenler
    duzlemEkseneAyarla(eksen: 'x' | 'y' | 'z' | '-x' | '-y' | '-z') {
        this.dinamikKesit.duzlemEkseneAyarla(eksen);
    }

    public kapa() {
        if (this.pencere) {
            this.pencere.kapa();
        }
    }
}
